import React, { useEffect } from "react";

import Confetti2 from "../../assets/confetti2.png";
import Confetti3 from "../../assets/confetti3.png";
import Confetti4 from "../../assets/confetti4.png";
import ZiplynesImpactImage from "../../assets/ZiplynesImpact.png";

import AOS from "aos";
import "aos/dist/aos.css";

const ZiplynesImpact = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  return (
    <div id="ZiplynesImpact">
      <div data-aos={"fade-left"} className="ZiplynesImpact--title">
        Ziplyne's Impact
      </div>
      <div data-aos={"zoom-in"} className="ZiplynesImpact--impacts">
        <div className="ZiplynesImpact--impact">
          Increased Application Usage and Process Efficiency
        </div>
        <div className="ZiplynesImpact--impact">
          Increased Training and Onboarding Efficiency
        </div>
        <div className="ZiplynesImpact--impact">
          Reduction in IT Support Calls and HelpDesk Tickets
        </div>
        <div className="ZiplynesImpact--impact">
          Consolidation of Software License Fees
        </div>
        <div className="ZiplynesImpact--impact">Reduced "Change Fatigue"</div>
        <div className="ZiplynesImpact--impact">
          Increased Flow and User Productivity
        </div>
        <div className="ZiplynesImpact--impact">
          Improved Employee Engagement and Experience
        </div>
        <div className="ZiplynesImpact--impact">
          Higher ROI and Adoption on Enterprise Software
        </div>
      </div>
      <img
        data-aos={"fade-right"}
        src={ZiplynesImpactImage}
        className="ZiplynesImpact--image"
        alt=""
      />
      <img className="ZiplynesImpact__confetti--2" src={Confetti2} alt="" />
      <img className="ZiplynesImpact__confetti--3" src={Confetti3} alt="" />
      <img className="ZiplynesImpact__confetti--4" src={Confetti4} alt="" />
    </div>
  );
};

export default ZiplynesImpact;
